import { render, staticRenderFns } from "./import.vue?vue&type=template&id=3ca6b4cc&scoped=true"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"
import style0 from "./import.vue?vue&type=style&index=0&id=3ca6b4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6b4cc",
  null
  
)

export default component.exports